import React from "react";
import { HStack } from "@chakra-ui/react";
import Dropdown from "react-dropdown";

export default function DepartmentDropdown(props: {
  handleSelectDepartment: any;
  handleNext: Function;
  preschool: any;
  placeHolder: string;
  departmentId: any;
  key?: any;
}) {
  return (
    <HStack spacing="5" w="fit-content">
      <Dropdown
        options={props.preschool?.departments
          ?.sort((a, b) => a.name.localeCompare(b.name, "sv"))
          .map(department => ({
            value: department.id,
            label: department.name,
          }))}
        onChange={selectedOption => {
          props.handleSelectDepartment(selectedOption);
          props.handleNext();
        }}
        value={props.preschool?.departments?.find(department => department.id === props.departmentId)?.name}
        placeholder={props.placeHolder}
        controlClassName={`custom-control w-preschool-department ${props.departmentId ? "" : "addError"}`}
        arrowClassName="custom-arrow"
        menuClassName="custom-menu"
        placeholderClassName="custom-placeholder"
      />
    </HStack>
  );
}
